import Vue from 'vue'

// TODO: Remove these global mixins and add them per component as needed...

import { authorizeMixin } from '@/bootstrap/authorizeMixin'
import { brandIdMixin } from '@/shared/js/mixins/brandIdMixin'

Vue.mixin(brandIdMixin)
Vue.mixin(authorizeMixin)
